module.exports = __webpack_public_path__ + "img/ewm.6bcb75f4.png";